import RedIndicator from 'emerald-ui/lib/RedIndicator';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: RedIndicator, componentName: 'RedIndicator' }], 'RedIndicator'),
  description: 'Puts a red circle on the wrapped element to denote a status change or a notification.',
  codeSamples: [
    {
      title: 'Default',
      scope: { RedIndicator, Icon },
      code: `<div style={{ display: 'flex' }}>
  <RedIndicator active={true} ariaLabel="mail">
    <Icon name="mail" />
  </RedIndicator>
</div>`,
    },
  ],
};
